<template>
  <div>
    <el-dialog
      v-if="visible"
      ref="dialog"
      v-dialog-drag
      :title="title"
      :visible.sync="visible"
      :width="loadWidth"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="inputForm" :model="inputForm" label-width="120px" :inline="isMb">
        <el-form-item label="岗位科研方向:" prop="postOrientations" required>
          <zr-combobox
            v-model="inputForm.postOrientations"
            :data-array="postOrientationsArray"
            value-field="code"
            label-field="name"
            @change="onPostOrientationsChange"
          ></zr-combobox>
        </el-form-item>
        <el-form-item
          v-if="isShowOther"
          label="其他具体内容："
          prop="otherOrientations"
          required
        >
          <el-input
            v-model="inputForm.otherOrientations"
            type="textbox"
            :autosize="{ minRows: 25, maxRows: 50 }"
            :max-length="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div>
          <el-button @click="visible = false">取消</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    researchOrientations: {
      type: String,
    },
    isMb:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      title: "选择科研方向",
      curI: null,
      inputForm: {},
      postOrientationsArray: [],
      isShowOther: false,
    };
  },
  computed: {},
  methods: {
    loadWidth() {
      if (this.isMb) {
        return "80%";
      } else {
        return "30%";
      }
    },
    onPostOrientationsChange(e) {
      if (e === "其它") {
        this.isShowOther = true;
        this.inputForm.otherOrientations = this.inputForm.researchOrientation;
      } else {
        this.isShowOther = false;
        this.inputForm.otherOrientations = "";
      }
    },
    confirm() {
      this.$refs.inputForm.validate(async (valid) => {
        if (!valid) return;
        this.$emit("confirm", this.inputForm);
        this.visible = false;
      });
    },
    showDialog(data) {
      if (
        this.researchOrientations !== null &&
        this.postOrientationsArray.length === 0
      ) {
        let list = this.researchOrientations.split(/[，,]/g);
        list.forEach((item) => {
          this.postOrientationsArray.push({ code: item, name: item });
        });
      }
      if (!this.postOrientationsArray.some((item) => item.name === "其它")) {
        this.postOrientationsArray.push({ code: "其它", name: "其它" });
      }
      this.visible = true;
      this.inputForm = data;
      this.inputForm={...this.inputForm,postOrientations:"",otherOrientations:""};
      //    if (
      //      this.inputForm.postOrientations &&
      //      this.inputForm.postOrientations === "其它"
      //    ) {
      //      this.isShowOther = true;
      //    }
      // if(this.inputForm.postOrientations){
      //   if(!this.postOrientationsArray.some(item => item.name===this.inputForm.postOrientations)){
      //     this.inputForm.postOrientations=""
      //   }
      // }
    },
  },
};
</script>

<style scoped></style>
